import React, { useEffect, useState, useCallback } from "react";
import ReactPaginate from "react-paginate";
import api from "../../axiosConfig";
import {
  Table,
  Button,
  InputGroup,
  FormControl,
  Container,
  Card,
  Spinner,
} from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import "../pagination.css";

function CatalogList() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchParams, setSearchParams] = useSearchParams();
  const search = searchParams.get("q") || "";

  const fetchItems = useCallback(async () => {
    setLoading(true);
    const skip = currentPage * itemsPerPage;
    try {
      const res = await api.get("/catalog", {
        params: {
          search,
          skip,
          limit: itemsPerPage,
        },
      });
      setItems(res.data?.items ?? []);
      setTotalCount(res.data?.total ?? 0);
    } catch (err) {
      console.error("Error loading catalogs:", err);
    } finally {
      setLoading(false);
    }
  }, [search, currentPage, itemsPerPage]);

  useEffect(() => {
    fetchItems();
  }, [fetchItems]);

  const handleSearchChange = (e) => {
    setSearchParams({ q: e.target.value });
    setCurrentPage(0);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Sigur dorești să ștergi acest catalog? Toate prețurile asociate vor fi șterse!")) {
      try {
        await api.delete(`/catalog/${id}`);
        fetchItems();
      } catch (err) {
        alert("Eroare la ștergere.");
      }
    }
  };

  const pageCount = Math.max(1, Math.ceil(totalCount / itemsPerPage));

  return (
    <Container className="mt-4">
      <Card className="shadow-sm border-0 p-4 bg-white rounded-3">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="text-dark fw-bold m-0">Cataloage de prețuri</h2>
          <Button variant="dark" className="px-4 py-2 fw-semibold rounded-2" onClick={() => navigate("/catalog/create")}>
            + Adaugă Catalog
          </Button>
        </div>

        <InputGroup className="mb-3">
          <FormControl
            placeholder="Caută catalog după denumire..."
            value={search}
            onChange={handleSearchChange}
            className="py-2 border-secondary-subtle"
          />
          {search && (
            <Button variant="outline-secondary" onClick={() => setSearchParams({})}>
              Curăță
            </Button>
          )}
        </InputGroup>

        <div className="d-flex justify-content-between align-items-center mb-3 text-muted small">
          <div>
            Rânduri pe pagină:&nbsp;
            <select
              value={itemsPerPage}
              onChange={(e) => {
                setItemsPerPage(parseInt(e.target.value));
                setCurrentPage(0);
              }}
              className="form-select-sm border-secondary-subtle rounded"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
            </select>
          </div>
          <div>Total: {totalCount} înregistrări</div>
        </div>

        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="dark" />
            <p className="text-muted mt-2 small">Se încarcă cataloagele...</p>
          </div>
        ) : (
          <>
            <Table responsive hover className="align-middle border-light-subtle mb-4">
              <thead className="table-light text-secondary">
                <tr>
                  <th style={{ width: 80 }}>ID</th>
                  <th>Denumire Catalog</th>
                  <th style={{ width: 200 }} className="text-end">Acțiuni</th>
                </tr>
              </thead>
              <tbody>
                {items.map((it) => (
                  <tr key={it.id}>
                    <td className="fw-semibold text-secondary">#{it.id}</td>
                    <td className="fw-semibold text-dark">{it.nume_catalog}</td>
                    <td className="text-end">
                      <Button
                        variant="outline-dark"
                        size="sm"
                        className="me-2 px-3"
                        onClick={() => navigate(`/catalog/${it.id}`)}
                      >
                        Administrează
                      </Button>
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => handleDelete(it.id)}
                      >
                        Șterge
                      </Button>
                    </td>
                  </tr>
                ))}
                {items.length === 0 && (
                  <tr>
                    <td colSpan={3} className="text-center py-4 text-muted">
                      Nu s-a găsit niciun catalog.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>

            <ReactPaginate
              previousLabel={"← Înapoi"}
              nextLabel={"Înainte →"}
              pageCount={pageCount}
              forcePage={currentPage}
              onPageChange={(event) => setCurrentPage(event.selected)}
              containerClassName={"pagination justify-content-center"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link text-dark"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link text-dark"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link text-dark"}
              activeClassName={"active"}
            />
          </>
        )}
      </Card>
    </Container>
  );
}

export default CatalogList;
